
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/uk/giveback",
      function () {
        return require("private-next-pages/uk/giveback.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/uk/giveback"])
      });
    }
  